import type { ItemHealth } from '@/common/api/types/dashboard/health';
import { HealthBadgeWithTooltip } from '@/features/insights-dashboard/components/shared/HealthBadgeWithTooltip';

export const HealthCell = ({ health }: { health: ItemHealth | undefined }) => {
  if (!health) {
    return null;
  }
  return (
    <HealthBadgeWithTooltip
      healthLevel={health.healthLevel}
      healthTypes={health.risks.map((risk) => risk.key)}
      className="max-w-full"
    />
  );
};
